/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Rating from '@mui/material/Rating'

import { positionChangeWidthSm, navbarHeight, footerHeight, hingeProfileBackgroundColor, hingeProfileImageDimension, swipelyticsTurquoise, profPicDefaultURL } from '../../../helpers/variableDefaults'
import { getPayload, getUserIdFromToken, getTokenFromLocalStorage } from '../../../helpers/storage'
import { descriptionTextField } from '../../../helpers/textfields'
import { standardButton } from '../../../helpers/buttons'
import { advisoryTypography, saveSuccessfulTypography } from '../../../helpers/typographies'
import { standardErrorContainer } from '../../../helpers/errors'

export const viewReviewerJSX = (isDemo, profileReview, setProfileReview, width, newReviewerReview, setNewReviewerReview, reviewerReviewErrors, setReviewerReviewErrors, loadingReviewerReview, setLoadingReviewerReview) => {

  const userIsClient = () => {
    return getUserIdFromToken(getTokenFromLocalStorage()).toString() === profileReview.userId.toString()
  }

  const handleReviewerReviewChange = (e) => {
    e.preventDefault()
    console.log('handleReviewerReviewChange runs')

    const { name, value } = e.target
    // console.log('name ->', name)
    // console.log('value ->', value)

    if (name === 'reviewText' && !(value.length > 0 && value.charAt(0) === ' ')) {
      // console.log('review should set')
      setNewReviewerReview({ ...newReviewerReview, reviewText: value })
    }
  }

  const handleSubmitReviewerReview = async () => {
    console.log('handleSubmitReviewerReview runs')

    const objectToUpload = { ...newReviewerReview }
    console.log('objectToUpload ->', objectToUpload)

    try {
      setLoadingReviewerReview(true)
      setReviewerReviewErrors(false)
      await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/reviewer-reviews/`, objectToUpload, {
        headers: {
          Authorization: `Bearer ${getTokenFromLocalStorage()}`,
        },
      })

      setProfileReview({ ...profileReview, reviewerReview: { ...objectToUpload } })

      setReviewerReviewErrors(false)
      setLoadingReviewerReview(false)

    } catch (err) {
      console.log('submit reviewer review error ->', err)

      setReviewerReviewErrors(true)
      setLoadingReviewerReview(false)
    }
  }

  return (
    <Box
      sx={{
        // mt: 3, 
        py: 2,
        width: hingeProfileImageDimension(width),
        backgroundColor: 'lightYellow',
        boxShadow: 3, 
        borderRadius: '10px',
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
      }}
    >

      {/* Title */}
      {/* <Box
        sx={{
          width: '100%',
          fontSize: '18px',
          fontWeight: 'bold',
          display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start',
        }}
      >
        Reviewer
      </Box> */}

      {/* Profile Picture */}
      {(
        (
          'isFriendReview' in profileReview 
          && profileReview.isFriendReview
        )
        ||
        ('isFriendReview' in profileReview 
          && !profileReview.isFriendReview
          && 'reviewerProfile' in profileReview
          && 'profilePicture' in profileReview.reviewerProfile
        )
      )
        &&
        <Box
          sx={{
            mt: 1,
            width: '100%',
            display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start',
          }}
        >
          <Link 
            to={profileReview.isFriendReview ? '#' : isDemo ? `/demo/${profileReview.bio.vitalInfo.firstName.toLowerCase()}/${profileReview.type}/${profileReview.reviewerProfile.bio.vitalInfo.firstName.toLowerCase().replace(/ /g,'')}/reviewer-profile` : `/reviewer-profile/${profileReview.reviewerProfile._id}`}
            // style={{
            //   textDecoration: 'none',
            //   ':hover': {
            //     textDecoration: 'none',
            //   },
            //   color: 'blue',
            // }}
          >
            <Box
              sx={{ 
                my: 1,
                width: width < positionChangeWidthSm ? '200px' : '200px',
                height: width < positionChangeWidthSm ? '200px' : '200px',
                backgroundImage: profileReview.isFriendReview ? `url(${profPicDefaultURL})` : `url(${profileReview.reviewerProfile.profilePicture})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                boxShadow: 3, 
                borderRadius: '50%', 
                display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', 
              }}
            />
          </Link>
        </Box>
      }

      {/* Name */}
      {'reviewerFirstName' in profileReview
        && 
        <Box
          textAlign={'center'}
          sx={{
            mt: 0,
            width: '100%',
            fontWeight: 'bold',
            display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start',
          }}
        >
          <Link 
            to={profileReview.isFriendReview ? '#' : isDemo ? `/demo/${profileReview.bio.vitalInfo.firstName.toLowerCase()}/${profileReview.type}/${profileReview.reviewerProfile.bio.vitalInfo.firstName.toLowerCase().replace(/ /g,'')}/reviewer-profile` : `/reviewer-profile/${profileReview.reviewerProfile._id}`}
            style={{
              textDecoration: 'none',
              ':hover': {
                textDecoration: 'none',
              },
              // color: 'blue',
            }}
          >
            {profileReview.reviewerFirstName}
          </Link>
        </Box>
      }

      {/* Friend Reviewer Email */}
      {profileReview.isFriendReview && 'reviewerEmail' in profileReview &&
        <Typography
          sx={{
            mt: 2,
            px: 2,
            width: '100%',
            fontWeight: 'bold',
            display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start',
          }}
        >
          {`${profileReview.reviewerEmail} `}
        </Typography>
      }

      {/* Usefulness */}
      <Typography
        sx={{
          mt: 2,
          px: 2,
          width: '100%',
          fontWeight: 'bold',
          display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start',
        }}
      >
        {profileReview.isFriendReview ? 'Friend Review' : profileReview.isAIReview ? `AI Review` : `How useful was ${profileReview.reviewerProfile.bio.vitalInfo.firstName}'s review?`}
      </Typography>

      {/* Star Rating */}
      {('reviewerReview' in profileReview && profileReview.reviewerReview !== null)
        ?
        <Box
          sx={{
            mt: 1,
            px: 2,
            width: '100%',
            display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start',
          }}
        >
          <Rating 
            name="starRating" 
            defaultValue={profileReview.reviewerReview.starRating} 
            precision={0.5} 
            readOnly 
          />
        </Box>
        :
        userIsClient()
        && !profileReview.isAIReview
        && !profileReview.isFriendReview
        && !loadingReviewerReview
          ?
          <Box
            sx={{
              mt: 1,
              px: 2,
              width: '100%',
              display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start',
            }}
          >
            <Rating
              name="starRating"
              value={newReviewerReview.starRating}
              precision={0.5} 
              onChange={(e, newStarRating) => {
                setNewReviewerReview({ ...newReviewerReview, starRating: newStarRating })
              }}
            />
          </Box>
          :
          <></>
      }

      {/* Review Text */}
      {'reviewerReview' in profileReview && profileReview.reviewerReview !== null
        ?
        <Box
          sx={{
            width: '100%',
            display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start',
          }}
        >
          <Typography
            sx={{
              px: 2, py: 2,
              mt: 1,
              backgroundColor: 'white',
              borderRadius: '10px',
              border: 2,
              borderColor: 'black',
              width: '75%',
              fontStyle: 'italic',
              display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            {profileReview.reviewerReview.reviewText.length > 0 ? profileReview.reviewerReview.reviewText : `No text review` }
          </ Typography>
        </Box>
        :
        userIsClient() && !profileReview.isAIReview && !profileReview.isFriendReview && !loadingReviewerReview
          ?
          <Box
            sx={{
              px: 2,
              mt: 1,
              width: '100%',
            }}
          >
            {descriptionTextField(
              'reviewText',
              newReviewerReview.reviewText,
              -1,
              ``,
              5,
              300,
              'What was useful or not useful about this review?',
              true,
              handleReviewerReviewChange,
              setReviewerReviewErrors,
              setNewReviewerReview,
              newReviewerReview,
              0
            )}
          </Box>
          :
          <></>
      }

      {(!('reviewerReview' in profileReview) || profileReview.reviewerReview === null)
        && !userIsClient() 
        && !profileReview.isAIReview
        && !profileReview.isFriendReview
        &&
          <Box
            sx={{
              width: '100%',
              display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start',
            }}
          >
            <Typography
              sx={{
                px: 2, py: 2,
                mt: 1,
                backgroundColor: 'white',
                borderRadius: '10px',
                border: 2,
                borderColor: 'black',
                width: '75%',
                fontStyle: 'italic',
                color: 'blue',
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start',
              }}
            >
              {`Waiting for review of ${profileReview.reviewerProfile.bio.vitalInfo.firstName} by client`}
            </ Typography>
          </Box>
      }

      {/* Submit Button */}
      {(!('reviewerReview' in profileReview) || profileReview.reviewerReview === null)
        && userIsClient() 
        && !profileReview.isAIReview
        && !profileReview.isFriendReview
        &&
          <Box 
            sx={{ 
              mt: 2,
              width: '100%',
              display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', 
            }}
          >
            {!loadingReviewerReview && standardButton(
              'Submit Review', 
              'button',
              'contained',
              newReviewerReview.starRating < 0 
              || newReviewerReview.reviewText.length < 20 
              || loadingReviewerReview,
              'primary', 
              0,
              0,
              0,
              '180px', 
              '45px', 
              handleSubmitReviewerReview
            )}
            <Box
              // textAlign={'left'}
              sx={{
                width: '180px',
                display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', 
              }}
            >
              {loadingReviewerReview && advisoryTypography(
                `Uploading review...`,
                'center'
              )}
              {reviewerReviewErrors && !loadingReviewerReview && standardErrorContainer(
                `There was an error uploading your review. Check your Internet connection and try again`, 
                0, 
                1
              )}
              {!loadingReviewerReview && advisoryTypography(
                `*Star rating required
                *Review text must be at least 20 characters`,
                'left'
              )}
            </Box>
            
          </Box>
      }


    </Box>
  )
}